import { render, staticRenderFns } from "./accounting-periods.vue?vue&type=template&id=cdcdfd16"
import script from "./accounting-periods.vue?vue&type=script&lang=js"
export * from "./accounting-periods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports